import { useMemo } from 'react';
import { ConfigType } from '@scale/shared/defaults';
import { TaskType } from '@scale/shared-types';
import { IProjectJson } from '@scale/shared/types/project';
import { IConfigMeta } from './useConfigData';
export type ConfigAttributes = Record<string, string>;

export const getConfigAttributes = (
  configMeta: IConfigMeta | undefined,
  projectData?: { taskType: TaskType; taskCustomer: string },
): ConfigAttributes | null => {
  if (!configMeta || (configMeta.type === ConfigType.Project && !projectData)) {
    return null;
  }
  const attrs: Record<string, string> = {};
  switch (configMeta.type) {
    case ConfigType.Project:
      attrs.project = configMeta.id!;
      if (projectData && projectData.taskType) {
        attrs.taskType = projectData.taskType;
      }
      attrs.taskCustomer = projectData!.taskCustomer;
      break;
    case ConfigType.TaskCustomerType:
      attrs.taskCustomer = configMeta.id!;
      if (configMeta.taskType) {
        attrs.taskType = configMeta.taskType;
      }
      break;
    case ConfigType.TaskCustomer:
      attrs.taskCustomer = configMeta.id!;
      break;
    case ConfigType.TaskType:
      if (configMeta.taskType) {
        attrs.taskType = configMeta.taskType;
      }
      break;
  }
  return attrs;
};

export const useConfigAttributes = (
  configMeta: IConfigMeta | undefined,
  project: IProjectJson | null | undefined,
): ConfigAttributes | null => {
  return useMemo(
    () => getConfigAttributes(configMeta, project ?? undefined),
    [configMeta, project],
  );
};
